module.exports = __webpack_public_path__ + "img/58exp.6a5141c0.jpg";